import type { ConfluencePage } from '../../types';

export const isConfluencePage = (entity: any): entity is ConfluencePage => {
	return entity.__typename === 'ConfluencePage';
};

export const getConfluencePageLink = (page: ConfluencePage): string | null => {
	const { base, webUi } = page.links ?? {};

	if (base === undefined || webUi === undefined || base.length === 0 || webUi.length === 0) {
		return null;
	}

	return `${base}${webUi}`;
};
